
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/debtreliefoffice",
      function () {
        return require("private-next-pages/debtreliefoffice/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/debtreliefoffice"])
      });
    }
  